import { PATHS, ELEMENT_TYPE } from '../config/constants';
import translations from './index';

const { humanTitle, humanNames, general, humanDesc } = translations;

export default {
  HD01: {
    id: 'HD01',
    title: humanNames.HD01,
    text: humanTitle.HD01,
    year: '1921 - 1951',
    description: humanDesc.HD01,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD01/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD01/HeroMobile.jpg',
    theme: 'white',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.DESIGNER,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD01/Related1.jpg',
        url: `${PATHS.PRODUCT}/PR05`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR05',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD01/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR03`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR03',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD01/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR01`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR01',
      },
    ],
    nextProduct: {
      id: 'HD02',
      text: general.nextHuman,
      url: `${PATHS.DESIGNER}/HD02`,
      type: ELEMENT_TYPE.DESIGNER,
    },
  },
  HD02: {
    id: 'HD02',
    title: humanNames.HD02,
    text: 'Directors',
    year: '1951 - 1967',
    description: humanDesc.HD02,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD02/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD02/HeroMobile.jpg',
    theme: 'black',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.DESIGNER,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD02/Related1.jpg',
        url: `${PATHS.MOMENT}/EV05`,
        type: ELEMENT_TYPE.MOMENT,
        id: 'EV05',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD02/Related2.jpg',
        url: `${PATHS.DESIGNER}/HD04`,
        type: ELEMENT_TYPE.DESIGNER,
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD02/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR09`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR09',
      },
    ],
    nextProduct: {
      id: 'HD03',
      text: general.nextHuman,
      url: `${PATHS.DESIGNER}/HD03`,
      type: ELEMENT_TYPE.DESIGNER,
    },
  },
  HD03: {
    id: 'HD03',
    title: humanNames.HD03,
    text: humanTitle.HD03,
    year: '1952 - 1980',
    description: humanDesc.HD03,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD03/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD03/HeroMobile.jpg',
    theme: 'black',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.DESIGNER,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD03/Related1.jpg',
        url: `${PATHS.MOMENT}/EV03`,
        type: ELEMENT_TYPE.MOMENT,
        id: 'EV03',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD03/Related2.jpg',
        url: `${PATHS.DESIGNER}/HD06`,
        type: ELEMENT_TYPE.DESIGNER,
      },
    ],
    nextProduct: {
      id: 'HD04',
      text: general.nextHuman,
      url: `${PATHS.DESIGNER}/HD04`,
      type: ELEMENT_TYPE.DESIGNER,
    },
  },
  HD04: {
    id: 'HD04',
    title: humanNames.HD04,
    text: humanTitle.HD04,
    year: '1953 - 1978',
    description: humanDesc.HD04,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD04/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD04/HeroMobile.jpg',
    theme: 'black',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.DESIGNER,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD04/Related1.jpg',
        url: `${PATHS.PRODUCT}/PR09`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR09',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD04/Related2.jpg',
        url: `${PATHS.MOMENT}/EV05`,
        type: ELEMENT_TYPE.MOMENT,
        id: 'EV05',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD04/Related3.jpg',
        url: `${PATHS.MOMENT}/EV06`,
        type: ELEMENT_TYPE.MOMENT,
        id: 'EV06',
      },
    ],
    nextProduct: {
      id: 'HD05',
      text: general.nextHuman,
      url: `${PATHS.DESIGNER}/HD05`,
      type: ELEMENT_TYPE.DESIGNER,
    },
  },
  HD05: {
    id: 'HD05',
    title: humanNames.HD05,
    text: humanTitle.HD05,
    year: '1954 - 1958',
    description: humanDesc.HD05,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD05/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD05/HeroMobile.jpg',
    theme: 'black',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.DESIGNER,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD05/Related1.jpg',
        url: `${PATHS.PRODUCT}/PR08`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR08',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD05/Related2.jpg',
        url: `${PATHS.MOMENT}/EV02`,
        type: ELEMENT_TYPE.MOMENT,
        id: 'EV02',
      },
    ],
    nextProduct: {
      id: 'HD06',
      text: general.nextHuman,
      url: `${PATHS.DESIGNER}/HD06`,
      type: ELEMENT_TYPE.DESIGNER,
    },
  },
  HD06: {
    id: 'HD06',
    title: humanNames.HD06,
    text: humanTitle.HD06,
    year: '1955 - 1958',
    description: humanDesc.HD06,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD06/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD06/HeroMobile.jpg',
    theme: 'black',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.DESIGNER,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD06/Related1.jpg',
        url: `${PATHS.MOMENT}/EV04`,
        type: ELEMENT_TYPE.MOMENT,
        id: 'EV04',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD06/Related2.jpg',
        url: `${PATHS.DESIGNER}/HD07`,
        type: ELEMENT_TYPE.DESIGNER,
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD06/Related3.jpg',
        url: `${PATHS.DESIGNER}/HD03`,
        type: ELEMENT_TYPE.DESIGNER,
      },
    ],
    nextProduct: {
      id: 'HD07',
      text: general.nextHuman,
      url: `${PATHS.DESIGNER}/HD07`,
      type: ELEMENT_TYPE.DESIGNER,
    },
  },
  HD07: {
    id: 'HD07',
    title: humanNames.HD07,
    text: humanTitle.HD07,
    year: '1955 - 1964',
    description: humanDesc.HD07,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD07/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD07/HeroMobile.jpg',
    theme: 'black',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.DESIGNER,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD07/Related1.jpg',
        url: `${PATHS.MOMENT}/EV04`,
        type: ELEMENT_TYPE.MOMENT,
        id: 'EV04',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1601464948/max-braun/designers/HD07/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR12`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR12',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD07/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR18`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR18',
      },
    ],
    nextProduct: {
      id: 'HD08',
      text: general.nextHuman,
      url: `${PATHS.DESIGNER}/HD08`,
      type: ELEMENT_TYPE.DESIGNER,
    },
  },
  HD08: {
    id: 'HD08',
    title: humanNames.HD08,
    text: humanTitle.HD08,
    year: '1955 - 1995',
    description: humanDesc.HD08,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD08/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD08/HeroMobile.jpg',
    theme: 'black',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.DESIGNER,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD08/Related1.jpg',
        url: `${PATHS.MOMENT}/EV07`,
        type: ELEMENT_TYPE.MOMENT,
        id: 'EV07',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD08/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR32`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR32',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD08/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR16`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR16',
      },
    ],
    nextProduct: {
      id: 'HD09',
      text: general.nextHuman,
      url: `${PATHS.DESIGNER}/HD09`,
      type: ELEMENT_TYPE.DESIGNER,
    },
  },
  HD09: {
    id: 'HD09',
    title: humanNames.HD09,
    text: humanTitle.HD09,
    year: '1959 - 1967',
    description: humanDesc.HD09,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD09/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD09/HeroMobile.jpg',
    theme: 'white',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.DESIGNER,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906762/max-braun/designers/HD09/Related1.jpg',
        url: `${PATHS.PRODUCT}/PR20`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR20',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD09/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR19`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR19',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD09/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR22`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR22',
      },
    ],
    nextProduct: {
      id: 'HD10',
      text: general.nextHuman,
      url: `${PATHS.DESIGNER}/HD10`,
      type: ELEMENT_TYPE.DESIGNER,
    },
  },
  HD10: {
    id: 'HD10',
    title: humanNames.HD10,
    text: humanTitle.HD10,
    year: '1962 - 1995',
    description: humanDesc.HD10,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD10/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD10/HeroMobile.jpg',
    theme: 'black',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.DESIGNER,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD10/Related1.jpg',
        url: `${PATHS.PRODUCT}/PR30`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR30',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD10/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR32`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR32',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1601465692/max-braun/designers/HD10/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR33`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR33',
      },
    ],
    nextProduct: {
      id: 'HD11',
      text: general.nextHuman,
      url: `${PATHS.DESIGNER}/HD11`,
      type: ELEMENT_TYPE.DESIGNER,
    },
  },
  HD11: {
    id: 'HD11',
    title: humanNames.HD11,
    text: humanTitle.HD11,
    year: '1970 - 2005',
    description: humanDesc.HD11,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD11/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD11/HeroMobile.jpg',
    theme: 'black',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.DESIGNER,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD11/Related1.jpg',
        url: `${PATHS.PRODUCT}/PR35`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR35',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD11/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR53`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR53',
      },
    ],
    nextProduct: {
      id: 'HD12',
      text: general.nextHuman,
      url: `${PATHS.DESIGNER}/HD12`,
      type: ELEMENT_TYPE.DESIGNER,
    },
  },
  HD12: {
    id: 'HD12',
    title: humanNames.HD12,
    text: humanTitle.HD12,
    year: '1973 - 2008',
    description: humanDesc.HD12,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD12/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD12/HeroMobile.jpg',
    theme: 'black',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.DESIGNER,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD12/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD08`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD08',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD12/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR44`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR44',
      },
    ],
    nextProduct: {
      id: 'HD13',
      text: general.nextHuman,
      url: `${PATHS.DESIGNER}/HD13`,
      type: ELEMENT_TYPE.DESIGNER,
    },
  },
  HD13: {
    id: 'HD13',
    title: humanNames.HD13,
    text: humanTitle.HD13,
    year: '2003 - present',
    description: humanDesc.HD13,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD13/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD13/HeroMobile.jpg',
    theme: 'black',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.DESIGNER,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD13/Related1.jpg',
        url: `${PATHS.PRODUCT}/PR49`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR49',
      },
    ],
    nextProduct: {
      id: 'HD14',
      text: general.nextHuman,
      url: `${PATHS.DESIGNER}/HD14`,
      type: ELEMENT_TYPE.DESIGNER,
    },
  },
  HD14: {
    id: 'HD14',
    title: humanNames.HD14,
    text: humanTitle.HD14,
    year: '2009 - present',
    description: humanDesc.HD14,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD14/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD14/HeroMobile.jpg',
    theme: 'black',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.DESIGNER,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD14/Related1.jpg',
        url: `${PATHS.PRODUCT}/PR48`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR48',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD14/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR52`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR52',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD14/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR53`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR53',
      },
    ],
    nextProduct: {
      id: 'HD15',
      text: general.nextHuman,
      url: `${PATHS.DESIGNER}/HD15`,
      type: ELEMENT_TYPE.DESIGNER,
    },
  },
  HD15: {
    id: 'HD15',
    title: humanNames.HD15,
    text: humanTitle.HD15,
    year: '2019 - present',
    description: humanDesc.HD15,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD15/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD15/HeroMobile.jpg',
    theme: 'white',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.DESIGNER,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD15/Related1.jpg',
        url: `${PATHS.PRODUCT}/PR47`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR47',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD15/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR48`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR48',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906554/max-braun/designers/HD15/Related3.jpg',
        url: `${PATHS.DESIGNER}/HD14`,
        type: ELEMENT_TYPE.DESIGNER,
      },
    ],
    nextProduct: {
      id: 'HD01',
      text: general.nextHuman,
      url: `${PATHS.DESIGNER}/HD01`,
      type: ELEMENT_TYPE.DESIGNER,
    },
  },
};
